/* eslint-disable @typescript-eslint/no-explicit-any */
import { GetServerSidePropsContext } from 'next';

import {
  BeekGraphqlSchema,
  initializeApollo,
} from 'src/api/apolloClient/apollo';
import { BeekUserRole } from 'src/utils/user';
import {
  GET_USER_ACCOUNT_SETTINGS_INFO,
  GET_USER_DEFAULT_PAYMENT_METHOD,
  GET_USER_EMAIL,
  GET_USER_EMAIL_EXISTS,
  GET_USER_PAYMENT_METHODS,
  GET_USER_PROFILE,
  GET_USER_SUBSCRIPTION_INFO,
} from './user';
import { HasSeenOnboardingDocument } from 'src/graphql/user';

export const getUserSubscriptionInfo = async (
  context?: GetServerSidePropsContext
): Promise<any> => {
  let data: any;
  try {
    const apolloClient = initializeApollo(BeekGraphqlSchema.api, context);
    data = await apolloClient.query({
      query: GET_USER_SUBSCRIPTION_INFO,
    });
  } catch (error: any) {
    return { error: { description: error.message } };
  }
  return data?.data?.viewer;
};

export const getUserDefaultPaymentMethod = async (
  context: GetServerSidePropsContext
): Promise<any> => {
  let data: any;
  try {
    const apolloClient = initializeApollo(BeekGraphqlSchema.api, context);
    data = await apolloClient.query({
      query: GET_USER_DEFAULT_PAYMENT_METHOD,
    });
  } catch (error: any) {
    return { error: { description: error.message } };
  }
  return data?.data?.viewer?.defaultPaymentMethod;
};

export const getUserPaymentMethods = async (
  context: GetServerSidePropsContext
): Promise<any> => {
  let data: any;
  try {
    const apolloClient = initializeApollo(BeekGraphqlSchema.api, context);
    data = await apolloClient.query({
      query: GET_USER_PAYMENT_METHODS,
    });
  } catch (error: any) {
    return { error: { description: error.message } };
  }
  return data?.data?.viewer?.paymentMethods;
};

export const getUserEmail = async (
  context: GetServerSidePropsContext
): Promise<any> => {
  let data: any;
  try {
    const apolloClient = initializeApollo(BeekGraphqlSchema.api, context);
    data = await apolloClient.query({
      query: GET_USER_EMAIL,
    });
  } catch (error: any) {
    return { error: { description: error.message } };
  }
  return data?.data?.viewer?.email;
};

export type UserProfile = Partial<{
  name: string;
  role: BeekUserRole;
  avatar: string;
  email: string;
  userId: string;
  error: { description: string };
}>;

export const getUserProfile = async (
  context?: GetServerSidePropsContext
): Promise<UserProfile> => {
  let data: any;
  try {
    const apolloClient = initializeApollo(BeekGraphqlSchema.api, context);
    data = await apolloClient.query({
      query: GET_USER_PROFILE,
    });
  } catch (error: any) {
    return { error: { description: error.message } };
  }
  return {
    name: data?.data?.viewer?.firstName,
    avatar: data?.data?.viewer?.avatar,
    role: data?.data?.viewer?.role,
    email: data?.data?.viewer?.userEmail,
    userId: data?.data?.viewer?.userId,
  };
};

export const getUserAccountSettingsInfo = async (
  context: GetServerSidePropsContext
): Promise<
  | {
      email: string;
    }
  | {
      error: {
        description: string;
      };
    }
> => {
  let data: any;
  try {
    const apolloClient = initializeApollo(BeekGraphqlSchema.api, context);
    data = await apolloClient.query({
      query: GET_USER_ACCOUNT_SETTINGS_INFO,
    });
  } catch (error: any) {
    return { error: { description: error.message } };
  }
  return {
    email: data?.data?.viewer?.email,
  };
};

export const hasSeenOnboarding = async (
  context: GetServerSidePropsContext
): Promise<any> => {
  let data: any;
  try {
    const apolloClient = initializeApollo(BeekGraphqlSchema.api, context);
    data = await apolloClient.query({
      query: HasSeenOnboardingDocument,
    });
  } catch (error: any) {
    return { error: { description: error.message } };
  }
  return data?.data?.viewer?.hasSeenOnboarding;
};

export const getUserEmailExists = async (email: string): Promise<any> => {
  let data: any;
  try {
    const apolloClient = initializeApollo(BeekGraphqlSchema.api);
    data = await apolloClient.query({
      query: GET_USER_EMAIL_EXISTS,
      variables: {
        email,
      },
      fetchPolicy: 'network-only',
    });
  } catch (error: any) {
    return { error: { description: error.message } };
  }

  return data?.data?.userExists;
};
